import React from 'react'

const Error403 = () => {
  return (
    <div style={{height:"100%"}}>
    <div
      style={{
        justifyContent: "center",
        alignContent: "center",
        alignItems: "center",
        height: "100%",
        display: "grid",
        fontSize: "30px",
      }}
    >
      <div
        style={{
          textAlign: "center",
          display: "grid",
          alignItems: "center",
          alignContent: "center",
          height: "100%",
        }}
      >
        <h1 class="w3-jumbo w3-animate-top w3-center">
          <code>Access Denied</code>
        </h1>
        <h4 class="w3-center w3-animate-right">
        You are not authorized to access this page or you are not registered for this tool. Please contact your administrator for assistance
        </h4>
        <h3 class="w3-center w3-animate-zoom">🚫🚫🚫🚫</h3>
        <h6 class="w3-center w3-animate-zoom">
          error code:403 forbidden
        </h6>
      </div>
    </div>
  </div>
  )
}

export default Error403
